import { render, staticRenderFns } from "./wrestler-icon.vue?vue&type=template&id=5f63ae0e&"
import script from "./wrestler-icon.vue?vue&type=script&lang=js&"
export * from "./wrestler-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports